import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BasketballStandingsComponent } from './basketball-standings/basketball-standings.component';
import { FootballStandingsComponent } from './football-standings/football-standings.component';
import { HandballStandingsComponent } from './handball-standings/handball-standings.component';
import { HockeyStandingsComponent } from './hockey-standings/hockey-standings.component';
import { VolleyballStandingsComponent } from './volleyball-standings/volleyball-standings.component';
import { SvgIconModule, TableModule, UtilsModule } from '@mtgame/ui';
import { RugbyStandingsComponent } from './rugby-standings/rugby-standings.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    UtilsModule,
    SvgIconModule
  ],
  declarations: [
    BasketballStandingsComponent,
    FootballStandingsComponent,
    HandballStandingsComponent,
    HockeyStandingsComponent,
    VolleyballStandingsComponent,
    RugbyStandingsComponent,
  ],
  exports: [
    BasketballStandingsComponent,
    FootballStandingsComponent,
    HandballStandingsComponent,
    HockeyStandingsComponent,
    VolleyballStandingsComponent,
    RugbyStandingsComponent,
  ]
})
export class TournamentStandingsModule {}
